"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaccinationDeclinationReason = void 0;
exports.instanceOfVaccinationDeclinationReason = instanceOfVaccinationDeclinationReason;
exports.VaccinationDeclinationReasonFromJSON = VaccinationDeclinationReasonFromJSON;
exports.VaccinationDeclinationReasonFromJSONTyped = VaccinationDeclinationReasonFromJSONTyped;
exports.VaccinationDeclinationReasonToJSON = VaccinationDeclinationReasonToJSON;
exports.VaccinationDeclinationReasonToJSONTyped = VaccinationDeclinationReasonToJSONTyped;
/**
 *
 * @export
 */
exports.VaccinationDeclinationReason = {
    MedicalReasons: 'MEDICAL_REASONS',
    ReligiousBeliefs: 'RELIGIOUS_BELIEFS',
    PersonalOrPhilosophicalReasons: 'PERSONAL_OR_PHILOSOPHICAL_REASONS',
    Other: 'OTHER'
};
function instanceOfVaccinationDeclinationReason(value) {
    for (const key in exports.VaccinationDeclinationReason) {
        if (Object.prototype.hasOwnProperty.call(exports.VaccinationDeclinationReason, key)) {
            if (exports.VaccinationDeclinationReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function VaccinationDeclinationReasonFromJSON(json) {
    return VaccinationDeclinationReasonFromJSONTyped(json, false);
}
function VaccinationDeclinationReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function VaccinationDeclinationReasonToJSON(value) {
    return value;
}
function VaccinationDeclinationReasonToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=VaccinationDeclinationReason.js.map